import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Address\GetAddressByIdController::__invoke
* @see app/Http/Controllers/Address/GetAddressByIdController.php
* @route '/api/address/{address}'
*/
const GetAddressByIdController = (args: { address: string | number | { id: string | number } } | [address: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAddressByIdController.url(args, options),
    method: 'get',
})

GetAddressByIdController.definition = {
    methods: ["get","head"],
    url: '/api/address/{address}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Address\GetAddressByIdController::__invoke
* @see app/Http/Controllers/Address/GetAddressByIdController.php
* @route '/api/address/{address}'
*/
GetAddressByIdController.url = (args: { address: string | number | { id: string | number } } | [address: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { address: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { address: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            address: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        address: typeof args.address === 'object'
        ? args.address.id
        : args.address,
    }

    return GetAddressByIdController.definition.url
            .replace('{address}', parsedArgs.address.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Address\GetAddressByIdController::__invoke
* @see app/Http/Controllers/Address/GetAddressByIdController.php
* @route '/api/address/{address}'
*/
GetAddressByIdController.get = (args: { address: string | number | { id: string | number } } | [address: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAddressByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Address\GetAddressByIdController::__invoke
* @see app/Http/Controllers/Address/GetAddressByIdController.php
* @route '/api/address/{address}'
*/
GetAddressByIdController.head = (args: { address: string | number | { id: string | number } } | [address: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAddressByIdController.url(args, options),
    method: 'head',
})

export default GetAddressByIdController